// extracted by mini-css-extract-plugin
module.exports = {"locale":"Header_locale__Me8o7","localeWrapper":"Header_localeWrapper__3T24o"};